<template>
  <v-card>
    <v-footer
      padless
      class="white--text text-center pa-1"
      color="grey darken-3"
      style="
        z-index: 200;
        border-radius: 0;
        font-size: 12px;
        position: fixed;
        bottom: 0;
        width: 100%;
      "
    >
      <v-row no-gutters>
        <v-col>
          <div style="float: left">&copy; Copyright BetMakers ASX:BET</div>
        </v-col>
        <v-col>
          <span>Build Number: </span>
          <span id="buildVersionNumber">FRONTENDVERSION</span>
        </v-col>
      </v-row>
    </v-footer>
  </v-card>
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style></style>
